<!-- 会员标签 -->
<template>
  <div class="center">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
    >
      <el-form-item label="标签名称" prop="title" label-width="200px">
        <el-input
          v-model="ruleForm.title"
          size="small"
          style="width: 34%"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="筛选条件"
        prop="name"
        label-width="200px"
        v-if="jude == 1"
      >
        <!-- 条件 -->
        <div class="methods">
          <div class="bottom20">请选择需要筛选条件</div>
          <el-form-item label="用户资料" label-width="17%">
            <div class="minbutton80">
              <el-button
                size="small"
                v-for="(item, index) in methodsData.user"
                :key="index"
                @click="optionCheck(item.index)"
                :type="trueList[item.index] ? 'primary' : ''"
                plain
                >{{ item.name }}</el-button
              >
            </div>
            <div class="minbutton80">
              <el-button
                size="small"
                v-for="(item, index) in methodsData.user2"
                :key="index"
                @click="optionCheck(item.index)"
                :type="trueList[item.index] ? 'primary' : ''"
                plain
                >{{ item.name }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="用户资产" label-width="17%">
            <div class="">
              <el-button
                size="small"
                v-for="(item, index) in methodsData.property"
                :key="index"
                @click="optionCheck(item.index)"
                class="minbutton80"
                :type="trueList[item.index] ? 'primary' : ''"
                plain
                >{{ item.name }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="交易数据" label-width="17%">
            <div class="">
              <el-button
                size="small"
                v-for="(item, index) in methodsData.deal"
                :key="index"
                @click="optionCheck(item.index)"
                class="minbutton80"
                :type="trueList[item.index] ? 'primary' : ''"
                plain
                >{{ item.name }}</el-button
              >
            </div>
            <div class="minbutton80">
              <el-button
                size="small"
                v-for="(item, index) in methodsData.recharge"
                :key="index"
                @click="optionCheck(item.index)"
                :type="trueList[item.index] ? 'primary' : ''"
                plain
                >{{ item.name }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="筛选满足以下" label-width="17%">
            <div class="spaceBetween">
              <div class="">
                <el-select
                  v-model="ruleForm.choose_num"
                  size="small"
                  style="width: 100px"
                >
                  <el-option label="所有" value="0"> </el-option>
                  <el-option label="任意" value="1"> </el-option>
                </el-select>
                条件的用户
              </div>
              <el-button size="small" class="minbutton80" @click="clear"
                >清空</el-button
              >
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[0]">
          <el-form-item label="性别" label-width="17%">
            <div class="spaceBetween">
              <el-checkbox-group v-model="sexArray">
                <el-checkbox label="1">男</el-checkbox>
                <el-checkbox label="2">女</el-checkbox>
                <el-checkbox label="0">未知</el-checkbox>
              </el-checkbox-group>
              <el-button type="text" @click="delect(0)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[1]">
          <el-form-item label="年龄" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-input
                  class="input20"
                  size="small"
                  v-model="ageArray[0]"
                  type="number"
                  min="0"
                  @blur="$set(ageArray, 0, Number(ageArray[0]).toFixed(0))"
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="ageArray[1]"
                  type="number"
                  @blur="$set(ageArray, 1, Number(ageArray[1]).toFixed(0))"
                ></el-input>
                <div class="padding15">
                  岁
                </div>
              </div>
              <el-button type="text" @click="delect(1)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[2]">
          <el-form-item label="生日" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="startBirthday[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in pageMonth"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  月
                </div>
                <el-select
                  v-model="startBirthday[1]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in pageday"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="">
                  日
                </div>
                <div class="padding15">
                  至
                </div>
                <el-select
                  v-model="endBirthday[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in pageMonth"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  月
                </div>
                <el-select
                  v-model="endBirthday[1]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in pageday"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  日
                </div>
              </div>
              <el-button type="text" @click="delect(2)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[3]">
          <el-form-item label="地域" label-width="17%">
            <div class="spaceBetween">
              <el-button
                icon="el-icon-plus"
                size="mini"
                class="padding15"
                @click="dialogTableVisible = true"
                >添加地域</el-button
              >
              <el-button type="text" @click="delect(3)">删除</el-button>
            </div>
            <div class="flex" style="flex-wrap: wrap">
              <el-tag
                v-for="(item, sonindex) in ruleForm.area"
                :key="sonindex"
                style="margin: 20px 20px 0 0; min-width: 80px; text-align: center"
              >
                {{ item }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[4]">
          <el-form-item label="会员等级" label-width="17%">
            <div class="spaceBetween">
              <div class="flex" style="align-items: center">
                <el-checkbox-group v-model="levels">
                  <el-checkbox
                    v-for="item in vipData"
                    :key="item.id"
                    :label="item.id"
                  >
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
                <!-- <el-radio-group>
                  <el-radio :label="3">有</el-radio>
                  <el-radio :label="6">备选项</el-radio>
                </el-radio-group> -->
              </div>
              <el-button type="text" @click="delect(4)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[5]">
          <el-form-item label="是否关注" label-width="17%">
            <div class="spaceBetween">
              <div class="flex" style="align-items: center">
                <el-radio-group v-model="ruleForm.subscribe">
                  <el-radio label="1">已关注</el-radio>
                  <el-radio label="2">未关注</el-radio>
                </el-radio-group>
              </div>
              <el-button type="text" @click="delect(5)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[6]">
          <el-form-item label="关注时间" label-width="17%">
            <div class="spaceBetween">
              <el-date-picker
                v-model="subscribeTime"
                value-format="yyyy-M-d"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
              >
              </el-date-picker>
              <el-button type="text" @click="delect(6)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <!-- <div class="bg" v-show="trueList[7]">
          <el-form-item label="关注门店" label-width="17%">
            <el-checkbox-group>
              <el-checkbox label="总店"></el-checkbox>
              <el-checkbox label="部分门店（不包含总店）"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div> -->
        <div class="bg" v-show="trueList[8]">
          <el-form-item label="是否领卡" label-width="17%">
            <div class="spaceBetween">
              <div class="flex" style="align-items: center">
                <el-radio-group>
                  <el-radio :label="3">已领卡</el-radio>
                  <el-radio :label="6">未领卡</el-radio>
                </el-radio-group>
              </div>
              <el-button type="text" @click="delect(8)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[9]">
          <el-form-item label="领卡时间" label-width="17%">
            <div class="spaceBetween">
              <el-date-picker
                v-model="take_cardTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                value-format="yyyy-M-d"
              >
              </el-date-picker>
              <el-button type="text" @click="delect(9)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <!-- <div class="bg" v-show="trueList[10]">
          <el-form-item label="领卡门店" label-width="17%">
            <el-checkbox-group>
              <el-checkbox label="总店"></el-checkbox>
              <el-checkbox label="部分门店（不包含总店）"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div> -->
        <div class="bg" v-show="trueList[11]">
          <el-form-item label="领卡渠道" label-width="17%">
            <div class="spaceBetween">
              <el-checkbox-group v-model="take_cardSource">
                <el-checkbox label="1">微信公众号</el-checkbox>
                <el-checkbox label="2">微信小程序</el-checkbox>
                <el-checkbox label="3">支付宝</el-checkbox>
              </el-checkbox-group>
              <el-button type="text" @click="delect(11)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[12]">
          <el-form-item label="可用余额" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-input
                  class="input20"
                  size="small"
                  v-model="balanceArray[0]"
                  type="number"
                  @blur="
                    $set(balanceArray, 0, Number(balanceArray[0]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="balanceArray[1]"
                  type="number"
                  @blur="
                    $set(balanceArray, 1, Number(balanceArray[1]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  元
                </div>
                <div class="color">注：-1表示无限制</div>
              </div>
              <el-button type="text" @click="delect(12)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[13]">
          <el-form-item label="可用积分" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-input
                  class="input20"
                  size="small"
                  v-model="pointArray[0]"
                  type="number"
                  @blur="$set(pointArray, 0, Number(pointArray[0]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="pointArray[1]"
                  type="number"
                  @blur="$set(pointArray, 1, Number(pointArray[1]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  积分
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(13)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[14]">
          <el-form-item label="消费次数" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="customNum[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内累计消费
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="customNum[1]"
                  type="number"
                  @blur="$set(customNum, 1, Number(customNum[1]).toFixed(0))"
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="customNum[2]"
                  type="number"
                  @blur="$set(customNum, 2, Number(customNum[2]).toFixed(0))"
                ></el-input>
                <div class="padding15">
                  次
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(14)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[15]">
          <el-form-item label="上次消费距今天数" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <div>
                  上次消费距今
                </div>
                <el-input
                  class="input20 padding15"
                  size="small"
                  v-model="last_customDay[0]"
                  type="number"
                  @blur="
                    $set(
                      last_customDay,
                      0,
                      Number(last_customDay[0]).toFixed(0)
                    )
                  "
                ></el-input>
                <div class="">
                  至
                </div>
                <el-input
                  class="input20 padding15"
                  size="small"
                  v-model="last_customDay[1]"
                  type="number"
                  @blur="
                    $set(
                      last_customDay,
                      1,
                      Number(last_customDay[1]).toFixed(0)
                    )
                  "
                ></el-input>
                <div class="">
                  天
                </div>
                <!-- <div class="color padding15">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(15)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[16]">
          <el-form-item label="累计消费金额" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="totalCustom[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内累计消费
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalCustom[1]"
                  type="number"
                  @blur="
                    $set(totalCustom, 1, Number(totalCustom[1]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalCustom[2]"
                  type="number"
                  @blur="
                    $set(totalCustom, 2, Number(totalCustom[2]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  元
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(16)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[17]">
          <el-form-item label="平均消费金额" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="avgCustom[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内平均消费
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="avgCustom[1]"
                  type="number"
                  @blur="$set(avgCustom, 1, Number(avgCustom[1]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="avgCustom[2]"
                  type="number"
                  @blur="$set(avgCustom, 2, Number(avgCustom[2]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  元
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(17)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[18]">
          <el-form-item label="充值次数" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="rechargeNum[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内累计充值
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="rechargeNum[1]"
                  type="number"
                  @blur="
                    $set(rechargeNum, 1, Number(rechargeNum[1]).toFixed(0))
                  "
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="rechargeNum[2]"
                  type="number"
                  @blur="
                    $set(rechargeNum, 2, Number(rechargeNum[2]).toFixed(0))
                  "
                ></el-input>
                <div class="padding15">
                  次
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(18)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[19]">
          <el-form-item label="上次充值距今天数" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <div>
                  上次充值距今
                </div>
                <el-input
                  class="input20 padding15"
                  size="small"
                  v-model="last_rechargeDay[0]"
                  type="number"
                  @blur="
                    $set(
                      last_rechargeDay,
                      0,
                      Number(last_rechargeDay[0]).toFixed(0)
                    )
                  "
                ></el-input>
                <div class="">
                  至
                </div>
                <el-input
                  class="input20 padding15"
                  size="small"
                  v-model="last_rechargeDay[1]"
                  type="number"
                  @blur="
                    $set(
                      last_rechargeDay,
                      1,
                      Number(last_rechargeDay[1]).toFixed(0)
                    )
                  "
                ></el-input>
                <div class="">
                  天
                </div>
                <!-- <div class="color padding15">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(19)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[20]">
          <el-form-item label="累计实充金额" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="totalRecharge[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内累计充值
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalRecharge[1]"
                  type="number"
                  @blur="
                    $set(totalRecharge, 1, Number(totalRecharge[1]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalRecharge[2]"
                  type="number"
                  @blur="
                    $set(totalRecharge, 2, Number(totalRecharge[2]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  元
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(20)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[21]">
          <el-form-item label="平均实充金额" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="avgRecharge[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内平均充值
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="avgRecharge[1]"
                  type="number"
                  @blur="
                    $set(avgRecharge, 1, Number(avgRecharge[1]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="avgRecharge[2]"
                  type="number"
                  @blur="
                    $set(avgRecharge, 2, Number(avgRecharge[2]).toFixed(2))
                  "
                ></el-input>
                <div class="padding15">
                  元
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(21)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[22]">
          <el-form-item label="累计获取积分" label-width="17%">
            <div class="spaceBetween">
              <div class="flex">
                <el-select
                  v-model="totalPoint[0]"
                  placeholder="请选择"
                  class="input20"
                  size="small"
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class="padding15">
                  天内累计获取
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalPoint[1]"
                  type="number"
                  @blur="$set(totalPoint, 1, Number(totalPoint[1]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  至
                </div>
                <el-input
                  class="input20"
                  size="small"
                  v-model="totalPoint[2]"
                  type="number"
                  @blur="$set(totalPoint, 2, Number(totalPoint[2]).toFixed(2))"
                ></el-input>
                <div class="padding15">
                  积分
                </div>
                <!-- <div class="color">注：-1表示无限制</div> -->
              </div>
              <el-button type="text" @click="delect(22)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[23]">
          <el-form-item label="是否充值" label-width="17%">
            <div class="spaceBetween">
              <div class="flex" style="align-items: center">
                <el-radio-group v-model="is_recharge">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </div>
              <el-button type="text" @click="delect(23)">删除</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="bg" v-show="trueList[24]">
          <el-form-item label="" label-width="17%">
            <div class="spaceBetween">
              <div class="flex" style="align-items: center">
                <el-input
                  v-model="no_custom"
                  size="small"
                  class="input90"
                ></el-input>
                <span>天未消费的会员</span>
              </div>
              <el-button type="text" @click="delect(24)">删除</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form-item>
    </el-form>
    <!-- 底部菜單 -->
    <div class="bottom">
      <el-button
        size="small"
        @click="$router.push({ path: `userSign?jude=${jude}` })"
        >取消</el-button
      >
      <el-button type="primary" size="small" @click="submit('ruleForm')"
        >保存</el-button
      >
    </div>
    <!-- 地区选择弹窗 -->
    <el-dialog title="添加区域" :visible.sync="dialogTableVisible">
      <div class="area">
        <div class="areaLeft">
          <div class="box-left">
            <el-checkbox-group v-model="checkList">
              <div
                class="felxBetween bottom10"
                v-for="(item, index) in areaOptions"
                :key="index"
                @change="areaChange(index)"
              >
                <el-checkbox :label="item.value">
                  {{ item.label }}
                </el-checkbox>
                <i class="el-icon-caret-right"></i>
              </div>
            </el-checkbox-group>
          </div>
          <div class="box-right">
            <el-checkbox-group v-model="checkListCity" @change="areaChange2">
              <div
                class="felxBetween bottom10"
                v-for="(item, index) in areaOptionsCheck"
                :key="index"
              >
                <el-checkbox :label="item.value">
                  {{ item.label }}
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="areaRight">
          <div class="top">已选省，市</div>
          <div class="cont">
            <div v-for="(item, index) in checkLast" :key="index">
              <div
                class="li"
                v-for="(son, sonindex) in item.children"
                :key="sonindex"
                v-show="item.children.length"
              >
                <div>{{ item.label }}{{ son.label }}</div>
                <el-button
                  type="text"
                  size="small"
                  @click="deleteArea(index, sonindex)"
                  >删除</el-button
                >
              </div>
              <div class="li" v-show="!item.children.length">
                <div>{{ item.label }}</div>
                <el-button type="text" size="small" @click="deleteArea(index)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="optionWindow(0)">取 消</el-button>
        <el-button type="primary" @click="optionWindow(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { areajson } from "@/components/public/area";
import time from "@/utils/time";
import {
  addTag,
  addCommonTag,
  eaditCommonTag,
  detailCommonTag
} from "@/api/market";
import { mapGetters } from "vuex";
import { vipList } from "@/api/vip";

export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      //
      pageMonth: time.numZero(12),
      pageday: time.numZero(30),
      idS: 0,
      jude: this.$route.query.jude, //2 为手动标签 1 自动标签
      methodsData: {
        user: [
          {
            name: "性别",
            index: 0
          },
          {
            name: "年龄",
            index: 1
          },
          {
            name: "生日",
            index: 2
          },
          {
            name: "地域",
            index: 3
          },
          {
            name: "会员等级",
            index: 4
          }
          // {
          //   name: "手机号",
          //   index: 4
          // }
        ],
        user2: [
          {
            name: "是否关注",
            index: 5
          },
          {
            name: "关注时间",
            index: 6
          },
          // {
          //   name: "关注门店",
          //   index: "7"
          // },
          // {
          //   name: "是否领卡",
          //   index: "8"
          // },
          {
            name: "领卡时间 ",
            index: "9"
          },
          // {
          //   name: "领卡门店",
          //   index: "10"
          // },
          {
            name: "领卡渠道 ",
            index: 11
          }
        ],
        property: [
          {
            name: "可用余额",
            index: 12
          },
          {
            name: "可用积分",
            index: 13
          }
        ],
        deal: [
          {
            name: "消费次数",
            index: 14
          },
          {
            name: "上次消费距今天数",
            index: 15
          },
          {
            name: "累计消费金额",
            index: 16
          },
          {
            name: "平均消费金额",
            index: 17
          },
          {
            name: "未消费会员",
            index: 24
          }
        ],
        recharge: [
          {
            name: "充值次数",
            index: 18
          },
          {
            name: "上次充值距今天数",
            index: 19
          },
          {
            name: "累计实充金额",
            index: 20
          },
          {
            name: "平均充值金额",
            index: 21
          },
          {
            name: "累计获取积分",
            index: 22
          },
          {
            name: "是否充值",
            index: 23
          }
        ]
      },
      ruleForm: {
        title: "",
        sex: "",
        age: "", //年龄 例如20,40
        brithday: "", //
        level_id: "", //会员等级
        subscribe: "", //	是否关注 1已关注 2未关注
        area: [],
        subscribe_time: "", //关注时间
        take_card_time: "", //领卡时间
        take_card_source: "", //领卡渠道 1微信公众号 2微信小程序 3支付宝
        balance: "", //可用余额 例如0,1000
        point: "", //可用积分 例如0,1000
        custom_num: "", //消费次数 例如7,0,10 代表7天内累计消费0-10次
        total_custom: "", //累计消费金额 例如7,0,1000 代表7天内累计消费0-1000元
        last_custom_day: "", //平均消费金额 例如7,0,1000 代表7天内平均消费0-1000元
        avg_custom: "",
        recharge_num: "", // 充值次数
        last_recharge_day: "", // 上次充值距今天数 例如0,10
        total_recharge: "", // 累计充值金额 例如7,0,1000 代表7天内累计充值0-1000元
        avg_recharge: "", // 平均充值金额 例如7,0,1000 代表7天内累计充值0-1000元
        total_point: "", // 平均充值金额 例如7,0,1000 代表7天内累计充值0-1000元
        choose_num: "0" //满足条件 0所有 1任意
      },
      levels: [], //会员等级
      rules: {
        title: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      sexArray: [], //性别
      ageArray: [], //年龄区间
      startBirthday: ["01", "01"], // 开始生日日期
      endBirthday: ["01", "01"], //
      subscribeTime: [], // 关注时间
      take_cardTime: [], // 领卡时间
      take_cardSource: [], //领卡渠道
      balanceArray: ["", ""], //可用余额
      pointArray: ["", ""], //可用积分
      customNum: [7, "", ""], //
      last_customDay: ["", ""],
      totalCustom: [7, "", ""], //
      avgCustom: [7, "", ""], //
      rechargeNum: [7, "", ""], //
      last_rechargeDay: ["", ""], //
      totalRecharge: [7, "", ""], //
      avgRecharge: [7, "", ""], //
      totalPoint: [7, "", ""], //
      is_recharge: "0", //是否充值过 1:是 2:否 0:未选择
      no_custom: "", // 未消费会员 天数
      trueList: [], //选中的列表
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        }
      ],
      dialogTableVisible: false,
      checkList: [],
      checkListCity: [], //市选择
      checkLast: [], //最终显示选择
      areaOptions: areajson, //调用外部js文件的json数据
      areaOptionsCheck: [], //省对应市的数
      dayList: [
        {
          value: "7",
          label: "7"
        },
        {
          value: "15",
          label: "15"
        },
        {
          value: "30",
          label: "30"
        },
        {
          value: "45",
          label: "45"
        },
        {
          value: "60",
          label: "60"
        },
        {
          value: "90",
          label: "90"
        },
        {
          value: "180",
          label: "180"
        },
        {
          value: "0",
          label: "所有"
        }
      ], //天"7", "15", "30", "45", "60", "90", "180", "所有"
      vipData: [], //会员等级
    };
  },
  mounted() {
    console.log("jude", this.jude, this.$route);
    console.log("time", time);
    if (localStorage.getItem("editCommon")) {
      this.idS = localStorage.getItem("editCommon");
      this.detailCommon();
      console.log("edfbianji ");
    }
    this.getVip();
  },
  components: {},
  methods: {
    getVip() {
      vipList({ token: this.token, app_id: this.app_id }).then(res => {
        console.log("vip", res);
        if (res.code == 200) {
          this.vipData = res.data;
        }
      });
    },
    //
    submit(formName) {
      // return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.jude == 1) {
            if (this.idS == 0) {
              for (let i = 0; i < this.trueList.length; i++) {
                if (this.trueList[i] == true) {
                  switch (i) {
                    case 0:
                      if (this.sexArray.length > 0) {
                        this.ruleForm.sex = this.sexArray.join(",");
                      } else {
                        this.$message.warning("请填写性别条件！！");
                        return;
                      }
                      break;
                    case 1:
                      if (this.ageArray.length == 2) {
                        this.ruleForm.age = this.ageArray.join(",");
                      } else {
                        this.$message.warning("请填写年龄条件！！");
                        return;
                      }
                      break;
                    case 4:
                      if (this.levels.length != 0) {
                        this.ruleForm.level_id = this.levels.join(",");
                      } else {
                        this.$message.warning("请选择会员等级！！");
                        return;
                      }
                      break;
                    case 2:
                      let B = [];
                      B.push(this.startBirthday.join("-"));
                      B.push(this.endBirthday.join("-"));

                      this.ruleForm.brithday = B.join(",");
                      break;
                    case 6:
                      if (this.subscribeTime.length == 2) {
                        this.ruleForm.subscribe_time = this.subscribeTime.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写关注时间条件！！");
                        return;
                      }
                      break;
                    case 9:
                      if (this.take_cardTime.length == 2) {
                        this.ruleForm.take_card_time = this.take_cardTime.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写领卡时间条件！！");
                        return;
                      }
                      break;
                    case 11:
                      if (this.take_cardSource.length > 0) {
                        this.ruleForm.take_card_source = this.take_cardSource.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写领卡渠道条件！！");
                        return;
                      }
                      break;
                    case 12:
                      if (
                        this.balanceArray[0] != "" &&
                        this.balanceArray[1] != ""
                      ) {
                        this.ruleForm.balance = this.balanceArray.join(",");
                      } else {
                        this.$message.warning("请填写可用余额条件！！");
                        return;
                      }
                      break;
                    case 13:
                      if (
                        this.pointArray[0] != "" &&
                        this.pointArray[1] != ""
                      ) {
                        this.ruleForm.point = this.pointArray.join(",");
                      } else {
                        this.$message.warning("请填写可用积分条件！！");
                        return;
                      }
                      break;
                    case 14:
                      if (this.customNum[1] != "" && this.customNum[2] != "") {
                        this.ruleForm.custom_num = this.customNum.join(",");
                      } else {
                        this.$message.warning("请填写消费次数条件！！");
                        return;
                      }
                      break;
                    case 15:
                      if (
                        this.last_customDay[1] != "" &&
                        this.last_customDay[0] != ""
                      ) {
                        this.ruleForm.last_custom_day = this.last_customDay.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写上次消费距今天数条件！！");
                        return;
                      }
                      break;
                    case 16:
                      if (
                        this.totalCustom[1] != "" &&
                        this.totalCustom[2] != ""
                      ) {
                        this.ruleForm.total_custom = this.totalCustom.join(",");
                      } else {
                        this.$message.warning("请填写累计消费金额条件！！");
                        return;
                      }
                      break;
                    case 17:
                      if (this.avgCustom[1] != "" && this.avgCustom[2] != "") {
                        this.ruleForm.avg_custom = this.avgCustom.join(",");
                      } else {
                        this.$message.warning("请填写平均消费金额条件！！");
                        return;
                      }
                      break;
                    case 18:
                      if (
                        this.rechargeNum[1] != "" &&
                        this.rechargeNum[2] != ""
                      ) {
                        this.ruleForm.recharge_num = this.rechargeNum.join(",");
                      } else {
                        this.$message.warning("请填写充值次数条件！！");
                        return;
                      }
                      break;
                    case 19:
                      if (
                        this.last_rechargeDay[1] != "" &&
                        this.last_rechargeDay[0] != ""
                      ) {
                        this.ruleForm.last_recharge_day = this.last_rechargeDay.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写上次充值距今天数条件！！");
                        return;
                      }
                      break;
                    case 20:
                      if (
                        this.totalRecharge[1] != "" &&
                        this.totalRecharge[2] != ""
                      ) {
                        this.ruleForm.total_recharge = this.totalRecharge.join(
                          ","
                        );
                      } else {
                        this.$message.warning("请填写累计充值金额条件！！");
                        return;
                      }
                      break;
                    case 21:
                      if (
                        this.avgRecharge[1] != "" &&
                        this.avgRecharge[2] != ""
                      ) {
                        this.ruleForm.avg_recharge = this.avgRecharge.join(",");
                      } else {
                        this.$message.warning("请填写平均充值金额条件！！");
                        return;
                      }
                      break;
                    case 22:
                      if (
                        this.totalPoint[1] != "" &&
                        this.totalPoint[2] != ""
                      ) {
                        this.ruleForm.total_point = this.totalPoint.join(",");
                      } else {
                        this.$message.warning("请填写累计获取积分条件！！");
                        return;
                      }
                      break;
                    case 23:
                      console.log(this.is_recharge);
                      this.ruleForm.is_recharge = this.is_recharge;
                      break;
                    case 24:
                      this.ruleForm.no_custom = this.no_custom;
                      break;
                  }
                }
              }
              let data = { ...this.ruleForm };
              data.token = this.token;
              data.app_id = this.app_id;
              data.is_recharge = this.trueList[23] ? this.is_recharge : "0";
              console.log("提交之前的数据", this.ruleForm);
              addTag(data).then(res => {
                console.log("保存标签", res);
                if (res.code == 400) {
                  this.$message({
                    message: res.msg,
                    type: "warning"
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success"
                  });
                  this.$router.go(-1);
                }
              });
            }
          } else if (this.jude == 2) {
            //
            console.log("手动标签addCommonTag");
            let data = {
              token: this.token,
              app_id: this.app_id,
              title: this.ruleForm.title
            };
            if (this.idS == 0) {
              console.log("提交手动标签数据", this.ruleForm);
              // return;
              addCommonTag(data).then(res => {
                console.log("保存手动标签", res);
                if (res.code == 400) {
                  this.$message({
                    message: res.msg,
                    type: "warning"
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success"
                  });
                  this.$router.push("userSign?jude= 2");
                }
              });
            } else {
              data.id = this.idS;
              eaditCommonTag(data).then(res => {
                console.log("保存手动标签", res);
                if (res.code == 400) {
                  this.$message({
                    message: res.msg,
                    type: "warning"
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success"
                  });
                  this.$router.push("userSign?jude= 2");
                }
              });
            }
          }
        } else {
          this.$message.warning("请填写标签名称！！");
        }
      });
    },
    // 地区选择
    areaChange(index) {
      // 去掉取消选择的数据
      let status = false; // 有重复的值时为true
      for (var i = 0; i < this.checkLast.length; i++) {
        console.log(
          "for循环",
          this.checkLast[i],
          this.areaOptions[index].value
        );
        if (this.checkLast[i].value * 1 == this.areaOptions[index].value) {
          status = true;
          this.checkLast.splice(i, 1);
          console.log("我有重复的值", this.checkLast);
          break;
        }
      }
      // if
      if (status) {
        this.areaOptionsCheck = [];
        console.log("重复值的路");
      } else {
        console.log("nonono值的路");
        this.areaOptionsCheck = this.areaOptions[index].children;
        let obj = {
          value: this.areaOptions[index].value,
          label: this.areaOptions[index].label,
          children: []
        };
        this.checkLast.push(obj);
      }
      console.log(
        "checkList",
        this.checkList,
        this.checkLast,
        this.areaOptionsCheck
      );
    },
    // 地区选择
    areaChange2(val) {
      console.log("areaChange2", val);
      // 清除之前的数据
      for (let m = 0; m < this.checkLast.length; m++) {
        this.checkLast[m].children = [];
      }
      //
      for (let i = 0; i < val.length; i++) {
        console.log("市选择的value", val[i]);
        for (let j = 0; j < this.areaOptions.length; j++) {
          if (
            this.areaOptions[j].value.substring(0, 2) == val[i].substring(0, 2)
          ) {
            console.log("相同父级", this.checkLast);
            for (let k = 0; k < this.areaOptions[j].children.length; k++) {
              if (this.areaOptions[j].children[k].value == val[i]) {
                console.log("子级寻找", this.areaOptions[j].children[k]);
                // 存储数据
                for (let m = 0; m < this.checkLast.length; m++) {
                  if (this.checkLast[m].value == this.areaOptions[j].value) {
                    let obj = {
                      label: this.areaOptions[j].children[k].label,
                      value: this.areaOptions[j].children[k].value
                    };
                    this.checkLast[m].children.push(obj);
                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
      console.log("结束", this.checkLast);
    },
    // 删除已选区域
    deleteArea(index, sonindex = "a") {
      // 默认a 不传为没有子级的情况
      if (sonindex == "a") {
        //
        this.checkList.splice(index, 1);
        this.checkLast.splice(index, 1);
        this.areaOptionsCheck = [];
      } else {
        if (this.checkLast[index].children.length > 1) {
          //
          this.checkListCity.splice(sonindex, 1);
          this.checkLast[index].children.splice(sonindex, 1);
        } else {
          this.checkList.splice(index, 1);
          this.checkListCity.splice(index, 1);
          this.checkLast.splice(index, 1);
          this.areaOptionsCheck = [];
        }
      }
      console.log("删除数据", index, sonindex);
    },
    //弹窗关闭
    optionWindow(jude) {
      if (jude) {
        this.ruleForm.area = [];
        for (let i = 0; i < this.checkLast.length; i++) {
          if (this.checkLast[i].children.length > 0) {
            for (let j = 0; j < this.checkLast[i].children.length; j++) {
              let newArr = [];
              newArr.push(this.checkLast[i].label);
              newArr.push(this.checkLast[i].children[j].label);
              this.ruleForm.area.push(newArr.join(","));
            }
          } else {
            this.ruleForm.area.push(this.checkLast[i].label);
          }
        }
      }
      console.log("页面地区渲染", this.ruleForm.area);
      // 关闭窗
      this.dialogTableVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    optionCheck(index) {
      let i = 0;
      let f = 0; //数组的长度
      for (i in this.trueList) {
        if (this.trueList[i] == true) f++;
      }
      if (f == 10 && this.trueList[index] != true) {
        this.$message.warning("最多可选择10个条件！");
        return;
      }
      this.trueList[index] = !this.trueList[index];
      this.$set(this.trueList, index, this.trueList[index]);
    },
    // 清空列表哦
    clear() {
      this.$confirm("确定要清空所选的条件选项吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          for (let i = 0; i < this.trueList.length; i++) {
            if (this.trueList[i] == true) {
              this.clearData(i);
            }
          }
          this.trueList = [];
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除某个条件
    delect(index) {
      this.clearData(index);
      this.$set(this.trueList, index, (this.trueList[index] = false));
    },
    clearData(index) {
      switch (index) {
        case 0:
          this.sexArray = [];
          break;
        case 1:
          this.ageArray = [];
          break;
        case 2:
          this.startBirthday = ["01", "01"];
          this.endBirthday = ["01", "01"];
          break;
        case 3:
          this.ruleForm.area = [];
          this.checkList = [];
          this.checkListCity = [];
          this.areaOptionsCheck = [];
          this.checkLast = [];
          this.endBirthday = [];
          break;
        case 5:
          this.ruleForm.subscribe = "";
          break;
        case 6:
          this.subscribeTime = ["", ""];
          break;
        case 9:
          this.take_cardTime = [];
          break;
        case 11:
          this.take_cardSource = [];
          break;
        case 12:
          this.balanceArray = ["", ""];
          break;
        case 13:
          this.pointArray = ["", ""];
          break;
        case 14:
          this.customNum = [7, "", ""];
          break;
        case 15:
          this.last_customDay = ["", ""];
          break;
        case 16:
          this.totalCustom = [7, "", ""];
          break;
        case 17:
          this.avgCustom = [7, "", ""];
          break;
        case 18:
          this.rechargeNum = [7, "", ""];
          break;
        case 19:
          this.last_rechargeDay = ["", ""];
          break;
        case 20:
          this.totalRecharge = [7, "", ""];
          break;
        case 21:
          this.avgRecharge = [7, "", ""];
          break;
        case 22:
          this.totalPoint = [7, "", ""];
          break;
        case 23:
          this.is_recharge = "0";
          break;
      }
    },
    // 手动标签编辑
    detailCommon() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        id: this.idS
      };
      detailCommonTag(data).then(res => {
        // this.ruleForm.title =
        this.ruleForm.title = res.data.title;
        console.log("详情", res);
      });
    }
  },
  destroyed: function() {
    console.log("我已经离开了！");
    localStorage.removeItem("editCommon");
  }
};
</script>
<style lang="scss" scoped>
.center {
  // width: 100%;
  height: 100%;
  padding: 10px;
  background: #fff;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  .el-form {
    flex: 1;
    padding: 10px;
    background: #f2f2f6;
    color: #595961;
    font-size: 12px;
    border-radius: 6px;
    overflow-y: auto;

    .methods {
      width: 100%;
      padding: 20px;
      background: #fff;
      border-radius: 6px;
    }
  }
  .bottom {
    height: 60px;
    padding: 10px;
    text-align: center;
  }
}
// 区域样式
.area {
  height: 334px;
  display: flex;
  > div {
    height: 100%;
    padding: 5px 12px;
  }
  .areaLeft {
    width: 60%;
    margin-right: 20px;
    border-radius: 6px;
    border: 1px solid #e3e2e5;
    display: flex;
    > div {
      width: 100%;
      padding: 5px 5px;
      overflow-y: auto;
    }
    .box-left {
      border-right: 1px solid #e3e2e5;
    }
  }
  .areaRight {
    flex: 1;
    border-radius: 6px;
    border: 1px solid #e3e2e5;
    display: flex;
    flex-direction: column;
    .top {
      height: 40px;
      line-height: 40px;
      font-weight: 700;
      border-bottom: 1px solid #e3e2e5;
    }
    .cont {
      overflow-y: auto;
      .li {
        margin-top: 10px;
        border-bottom: 1px solid #e3e2e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
// 通用样式
.bottom20 {
  margin-bottom: 20px;
}
.bottom10 {
  margin-bottom: 10px;
}
.minbutton80 {
  min-width: 80px;
  cursor: pointer;
  margin-bottom: 20px;
}
.bg {
  background: #fff;
  margin-top: 10px;
  padding: 15px 20px;
  border-radius: 6px;
}
.input20 {
  width: 20%;
  height: 30px;
}
.input90 {
  width: 90px;
  margin-right: 10px;
}
.padding15 {
  padding: 0 15px;
}
.el-input__inner {
  height: 100%;
}
.flex {
  display: flex;
}
.color {
  color: #9797a1;
}
.felxBetween {
  display: flex;
  justify-content: space-between;
}
.el-checkbox-group {
  font-size: 14px;
}
.spaceBetween {
  display: flex;
  justify-content: space-between;
}
</style>
